export function maskPhoneNumber(value: string): string {
  const phone = value.trim();
  const allDigits = phone.replace(/\D/g, '');
  // Platform stores mainland numbers with the country code (8619900009901);
  // drop +86 / 0086 / 86 so the mask shows 199****9901, not 861****9901.
  const mainland = allDigits.match(/^(?:0086|86)(1\d{10})$/);
  const digits = mainland ? mainland[1] : allDigits;

  if (digits.length >= 7) {
    return `${digits.slice(0, 3)}****${digits.slice(-4)}`;
  }

  return maskGenericIdentifier(phone);
}

export function maskGenericIdentifier(value: string): string {
  const identifier = value.trim();

  if (!identifier) return '***';
  return `${identifier.slice(0, 1)}***`;
}

export function maskUsername(value: string): string {
  const username = value.trim();
  const at = username.indexOf('@');
  const visiblePart = at > 0 ? username.slice(0, at) : username;
  const phoneLike = visiblePart.replace(/[\s()+-]/g, '');

  if (/^\d{7,}$/.test(phoneLike)) return maskPhoneNumber(visiblePart);
  return maskGenericIdentifier(visiblePart);
}
